module.exports = __webpack_public_path__ + "img/neoburger-mobile.ba26885f.png";